<template>
  <div class="infoTable" :style="parentStyle">
    <template v-show="hasData">
      <table boder="0" cellpadding="0" cellspacing="0">
        <tbody>
          <tr v-for="(el, index) in option.column" :key="el.index" :style="tableStyle(index)">
            <td class="tablename" :style="tdnameStyle">{{ el.label }}</td>
            <td
              class="tablevalue"
              :style="tdvalueStyle"
              @click="goLink(el.label, dataChart[el.prop])"
            >
              {{ dataChart[el.prop] }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-if="!hasData">
      <avue-echart-empty />
    </template>
  </div>
</template>
<script>
import init from '@/mixins/chart';
export default {
  name: 'table1',
  mixins: [init],
  props: {
    option: Object,
    component: Object
  },
  computed: {
    parentStyle() {
      return {
        fontWeight: this.option.fontWeight || 'normal'
      };
    },
    hasData() {
      return this.option.column?.length > 0;
    },
    tdnameStyle() {
      return {
        textAlign: this.option.titlePostion || 'left',
        fontSize: (this.option.fontSize || 30) + 'px',
        fontWeight: this.option.fontWeight || 'normal',
        'background-color': this.option.oddColor || '',
        color: this.option.trColor || '#fff'
      };
    },
    tdvalueStyle() {
      return {
        textAlign: this.option.tdPostion || 'left',
        'background-color': this.option.evenColor || '',
        fontWeight: this.option.fonttdWeight || 'normal',
        color: this.option.tdColor || '#fff',
        fontSize: (this.option.fonttdSize || 30) + 'px'
      };
    }
  },

  methods: {
    tableStyle(index) {
      //判断是奇数行还是偶数行
      if (index % 2 == 0) {
        return {
          'background-color': this.option.oddBgc || ''
        };
      } else {
        return {
          'background-color': this.option.evenBgc || ''
        };
      }
    },
    goLink(n, v) {
      this.tableClick({ name: n, value: v });
    }
  }
};
</script>
<style lang="scss">
.infoTable {
  width: 100%;
  border: none;
  .tablename {
    max-width: 120px;
    width: 120px;
    padding: 20px 8px;
  }
  .tablevalue {
    padding: 20px 55px;
    padding-right: 75px;
  }
}
</style>
